import type { HomePageContentData } from '../services/api';

/** Client fallback if public API fails (keep in sync with backend `home_page_defaults.py`). */
export const FALLBACK_HOME_PAGE_CONTENT: HomePageContentData = {
  hero_title: 'CREDENTIAL COMMUNITY LANGUAGE TEST',
  hero_subtitle: 'The first, biggest, and the most successful community created ever.',
  cta_button_label: 'Start Practice',
  services_section_title: 'Our Services',
  service_cards: [
    {
      title: 'MATERIAL AND RESOURCES',
      items: [
        'Repeated Test Dialogues Form 2018',
        'Basic, Normal, & Advanced Practices',
        'Standard Mock Test',
        'Test Essential Vocabulary by CMT',
      ],
    },
    {
      title: 'REAL TEST SIMULATOR',
      items: [
        'Voice Recorder system',
        'Video Camera Platform',
        'Read Test Criteria',
        'Test Auto Play',
      ],
    },
    {
      title: 'EVALUATION INDICATORS',
      items: [
        'Performance Review system',
        'Superior Progression Level',
        'Note Lookback Platform',
        'Test Difficulty Index',
      ],
    },
    {
      title: 'SPECIAL SERVICES',
      items: [
        'Real Test Experience',
        'Test Marking Services',
        'Test Review Platform',
        'Ask for Feedback',
      ],
    },
  ],
  about_title: 'What is NAATI Test?',
  about_body:
    'The Credentialed Community Language Test, known as the NAATI Test, is an interpreting test for evaluation of your language quality and capabilities in community level. In this test, candidates interpret two conversations between an English speaker and a Language Other Than English (LOTE) to demonstrate accurate comprehension of each language. During NAATI Test, an audio recording is played by a test officer which includes topics in Australian society such as health, legal, immigration, finance, housing, education, etc. NAATI Test candidates after passing the naati exam are only able to claim 5 bonus points for their visa applications in 189,190, and 491 subclasses and NOT working as a certified interpreter or translator.',
  footer_tagline:
    'The first, biggest, and the most successful community created ever for NAATI Test preparation.',
  contact_email: 'info@naatipanel.com',
  contact_phone: '+61 2 1234 5678',
  contact_address: 'Sydney, Australia',
  instagram_url: 'https://instagram.com/your-instagram',
  telegram_url: 'https://t.me/your-telegram',
  footer_copyright: '© 2024 NAATI Panel. All rights reserved.',
};
